var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"mx-1",attrs:{"variant":_vm.eventColor,"pill":""}},[_vm._v(_vm._s(_vm.event))])
}
var staticRenderFns = []

export { render, staticRenderFns }